import ProjectCollection from "./ProjectCollection";
import Social from "./Social";
import Resource from "./Resource";

export default {
  ProjectCollection,
  Social,
  Resource
};
